import { useState, useEffect } from 'react';

export function useSessionState(key, initialValue) {
  const getStoredValue = () => {
    const storedValue = sessionStorage.getItem(key);
    let value;
    if (storedValue != null) {
      try {
        value = JSON.parse(storedValue);
      } catch (e) {
        console.warn('Failed to parse sessionStorage value for key:', key, e);
      }
    }
    if (typeof initialValue === 'function') {
      return initialValue(value);
    } else if (value) {
      return value;
    }
    return initialValue;
  };

  const [value, setValue] = useState(getStoredValue);

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.warn('Failed to save value to sessionStorage for key:', key, e);
    }
  }, [key, value]);

  return [value, setValue];
}
